import { render, staticRenderFns } from "./investStatistics.vue?vue&type=template&id=c0b696ac&"
import script from "./investStatistics.vue?vue&type=script&lang=js&"
export * from "./investStatistics.vue?vue&type=script&lang=js&"
import style0 from "./investStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports